import { User } from '@shared/interfaces/user';

export function extractUserObject(userData: string[]): Omit<User, '_id'> | { [key: string]: never } {
  try {
    const user = JSON.parse(userData[1]);
    delete user.__v;
    return user;
  } catch (error) {
    console.error('Error parsing user data:', error);
    return {};
  }
}

export function encapsulateString(value: string | boolean | number | string[] | null): string {
  if (value === null || value === undefined) return '';
  return `"${value
    .toString()
    .replace(/"/g, "'")
    .replace(/\r?\n|\r/g, ' ')}"`;
}

export function calcAverage(array: string[][], arrayIndex: number): number | null {
  if (array.length === 0 || arrayIndex < 0) return null;
  return (
    array.reduce((acc, row) => {
      const rating = row[arrayIndex].replaceAll('"', '');
      return acc + Number(rating);
    }, 0) / array.length
  );
}
